import { AxiosRequest } from "../../../Url";
import { getTableLayout } from "../../Tools/Requests";
import { defaultFieldInfo, getRightsData, setColor } from "../../Tools/Tools";
import { CreateCollapsibleRecords } from "../GridTools/collapsibleRecordsTools";
import { getParamColumnsOptions, parseColumns } from "../GridTools/parseColumnTools";
import smetaAxios from "../../../SmetaAxios";
import { createGrid, createRecordSource } from "../rcsgrid";
import { DelphiColors, ParamSetOption, Prefixes } from "../../Tools/ProjectX";
import { HTMLGridTableCellElement, HTMLGridTableElement } from "../../../ComponentInterface";
import { EventDataInfo } from "../../Tools/VirtualList/VirtualList";

const changeGridStyles = async (table: HTMLGridTableElement, grid: createGrid) => {
  for (const cell of Array.from(table.querySelectorAll<HTMLGridTableCellElement>(".grid-td"))) {
    const { fieldName } = cell.field;
    if (fieldName === "UsedDocs") {
      const fieldText = await grid.source.getFieldText("UsedDocs");
      const fieldValue = await grid.source.getFieldValue("HasUsedDocs");
      const hasTextAndIsEmpty = fieldText && fieldValue === undefined;
      if (hasTextAndIsEmpty) cell.style.color = setColor(DelphiColors.clGray);
    }
  }
};

export async function accCorsGrid(grid: createGrid, source: createRecordSource, props, data) {
  const currentAccCorrIsConfig = () => {
    return Number(source.getFieldTextSync("ID")) > 0 && Number(source.getFieldTextSync("CfgID")) === 0;
  };

  const docsDropDownList = async () => {
    const json = await smetaAxios.get<{ Items?: { items?: { Text: string; ID: string }[] } }>("GetDocumentTypes", {
      prefix: Prefixes.acctools,
      params: { ID: source.getFieldTextSync("ID") },
      loadMask: true,
    });
    if (json.Items?.items) {
      return json.Items.items.map((item) => ({ id: item.ID, label: item.Text }));
    }
    return [];
  };

  const docsGetListCheckState = (value: EventDataInfo) => {
    return Number(value.id) < 0;
  };

  const docsSetListCheckState = async (value: EventDataInfo, checked: boolean) => {
    const docId = Math.abs(Number(value.id));
    await smetaAxios.get("SetCheckState", {
      prefix: Prefixes.acctools,
      params: {
        SectionID: props.SectionID,
        ID: source.getFieldTextSync("ID"),
        DocCfgID: docId,
        State: checked ? "1" : "0",
      },
      loadMask: true,
    });
    value.id = String(checked ? -docId : docId);
    await grid.refreshSource("!");
  };

  grid.changeGridStyles = changeGridStyles;
  const json = await getTableLayout({ module: Prefixes.acctools });
  let columns = {
    title: [
      {
        collapseRecord: true,
        fieldName: "Name",
        title: "Наименование операции",
        width: 300,
        level: 0,
        fieldInfo: {
          ...defaultFieldInfo,
          options: getParamColumnsOptions(ParamSetOption.Fixed + ParamSetOption.Sortable),
        },
      },
    ],
  };
  source.onHandleRequest = handleRequest(props);
  source.CreateCollapsibleRecords = CreateCollapsibleRecords;
  await source.open();
  if (json) {
    source.rights = getRightsData(json.Rights);
    data.setCanSaveToConfig?.(json.CanSaveToConfig === "1");
    columns = parseColumns(json, { inputColumns: columns });
    const usedDocsColumn = columns.title.find((column) => column.fieldName === "UsedDocs");
    if (usedDocsColumn?.fieldInfo) {
      usedDocsColumn.fieldInfo.onDropDownList = docsDropDownList;
      usedDocsColumn.fieldInfo.onGetListCheckState = docsGetListCheckState;
      usedDocsColumn.fieldInfo.onSetListCheckState = docsSetListCheckState;
    }
    grid.setColumns(columns);
  } else grid.setColumns(columns);
  grid.setImageFields(["ID"]);
  source.booksGetImage = () => {
    if (currentAccCorrIsConfig()) return 3;
    if (source.getFieldTextSync("CfgID") !== "") return 2;
    return "";
  };
  await grid.setSource(source);
  source.onRecordCollapsed = async (event) => {
    const recordIndex =
      event.currentTarget !== undefined ? event.currentTarget.getAttribute("recordindex") : await event;
    await smetaAxios.get("RecordCollapsed", {
      prefix: props.Module,
      params: { SectionID: props.SectionID, RecordIndex: recordIndex },
      loadMask: true,
    });
    await grid.refreshSource("!");
  };
  if (data.setSelectedRecord) {
    source.onRecordIndexChanged = (source) => {
      data.setSelectedRecord(source.getFieldTextSync("ID"));
    };
    data.setSelectedRecord(source.getFieldTextSync("ID"));
  }
  if (props.ObjRef) await grid.refreshSource(props.ObjRef);
  await grid.updateGridSize();
}

function handleRequest({ SectionID }: { SectionID: string }) {
  return (request) => {
    const params = new Map();
    params.set("prefix", Prefixes.acctools).set("comand", "HandleTable").set("SectionID", SectionID);
    return AxiosRequest(true, params, request);
  };
}
